import ApiService from './ApiService'

export type ProjectCreationResponse = {
  id: string
  projectName: string
  mainPackage: string
  projectType: 'PROJECT' | 'SINGLE_SERVICE'
  specsStatus: 'NOT_GENERATED' | 'GENERATED'
  createdDate: string
  demo: boolean
}

export type ProjectDescriptionValidationResponse = {
  validated: boolean
  validationText: string
  improvedPrompt: string
}

export type ProjectDetailResponse = {
  specs: string
  diagram: string
  step: 'GENERATING' | 'GENERATED' | 'VALIDATED' | 'FAILED'
  estimateTime: number
  progress: number
  demo: boolean
  microServicesShredCount: Record<string, number> | null
}

export async function apiGetProjectList<T>() {
  return ApiService.fetchData<T>({
    url: '/api/projects',
    method: 'get',
  })
}

export async function apiGetProjectDetails<T>(
  projectId: string,
) {
  return ApiService.fetchData<T>({
    url: `/api/projects/${projectId}/specs`,
    method: 'get',
  })
}

export async function apiCreateProjectList<T, U extends Record<string, unknown>>(
  data: U
) {
  return ApiService.fetchData<T>({
    url: '/api/projects',
    method: 'post',
    data: {...data, projectType: 'PROJECT'},
  })
}

export async function apiCreateSimpleProjectList<T, U extends Record<string, unknown>>(
  data: U
) {
  return ApiService.fetchData<T>({
    url: '/api/projects',
    method: 'post',
    data: {...data, projectType: 'SINGLE_SERVICE',},
  })
}

export async function apiValidateDescription<T>(
  projectDescription: string
) {
  return ApiService.fetchData<T>({
    url: '/api/projects/validate',
    method: 'post',
    params: {type: 'ARCHITECTURE_PROMPT'},
    data: {prompt: projectDescription},
  })
}

export async function apiGenerateProjectSpecs<T>(
  projectId: string,
  projectDescription: string
) {
  return ApiService.fetchData<T>({
    url: `/api/projects/${projectId}/specs`,
    method: 'post',
    data: {specs: projectDescription},
  })
}

export async function apiResumeProjectSpecs<T>(
  projectId: string,
  force: boolean,
) {
  return ApiService.fetchData<T>({
    url: `/api/projects/${projectId}/specs/resume/${force}`,
    method: 'post',
  })
}

export async function apiValidateProjectSpecs<T>(
  projectId: string,
) {
  return ApiService.fetchData<T>({
    url: `/api/projects/${projectId}/services`,
    method: 'get',
  })
}